// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `form {
  width: 100%;
  gap: 1rem;
}
form .form-group {
  gap: 0.5rem;
}
form .form-group label {
  font-weight: bold;
}

#prestador > div:nth-child(2) span {
  font-weight: bold;
}
#prestador > div:nth-child(2) div.d-flex {
  gap: 0.5rem;
}
#prestador > div:nth-child(2) input {
  width: auto;
  min-width: 25rem;
}

@media (max-width: 767.98px) {
  form .form-group {
    width: 100%;
  }
  form .form-group input,
  form .form-group select {
    flex-grow: 1;
  }
  form .form-group:last-child:not(.multiples) {
    justify-content: center;
  }
  form .form-group.multiples:last-child > app-button {
    width: 49%;
  }
  #prestador > div:nth-child(2) > div#actualizar-correo-alternativo > div {
    flex-direction: column;
  }
}
@media (max-width: 575.98px) {
  form {
    flex-direction: column;
    gap: initial;
  }
  form * {
    width: 100% !important;
  }
  #prestador > div:nth-child(2) > div#correo-alternativo > div {
    flex-direction: column;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/expedientes-crear/expedientes-crear.component.scss"],"names":[],"mappings":"AAAA;EACC,WAAA;EACA,SAAA;AACD;AAAC;EACC,WAAA;AAEF;AADQ;EACI,iBAAA;AAGZ;;AAIQ;EACI,iBAAA;AADZ;AAGQ;EACI,WAAA;AADZ;AAGQ;EACI,WAAA;EACA,gBAAA;AADZ;;AAMA;EACC;IACC,WAAA;EAHA;EAIA;;IAEC,YAAA;EAFD;EAIA;IACC,uBAAA;EAFD;EAIA;IACC,UAAA;EAFD;EAKD;IACC,sBAAA;EAHA;AACF;AAMA;EACC;IACC,sBAAA;IACA,YAAA;EAJA;EAKA;IACC,sBAAA;EAHD;EAMD;IACC,sBAAA;EAJA;AACF","sourcesContent":["form {\n\twidth: 100%;\n\tgap: 1rem;\n\t& .form-group {\n\t\tgap: 0.5rem;\n        & label {\n            font-weight: bold;\n        }\n\t}\n}\n\n#prestador {\n    & > div:nth-child(2) {\n        & span {\n            font-weight: bold;\n        }\n        & div.d-flex {\n            gap: 0.5rem;\n        }\n        & input {\n            width: auto;\n            min-width: 25rem;\n        }\n    }\n}\n\n@media (max-width: 767.98px) {\n\tform .form-group {\n\t\twidth: 100%;\n\t\t& input,\n\t\tselect {\n\t\t\tflex-grow: 1;\n\t\t}\n\t\t&:last-child:not(.multiples) {\n\t\t\tjustify-content: center;\n\t\t}\n\t\t&.multiples:last-child > app-button {\n\t\t\twidth: 49%;\n\t\t}\n\t}\n\t#prestador > div:nth-child(2) > div#actualizar-correo-alternativo > div {\n\t\tflex-direction: column;\n\t}\n}\n\n@media (max-width: 575.98px) {\n\tform {\n\t\tflex-direction: column;\n\t\tgap: initial;\n\t\t& * {\n\t\t\twidth: 100% !important;\n\t\t}\n\t}\n\t#prestador > div:nth-child(2) > div#correo-alternativo > div {\n\t\tflex-direction: column;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
